<template>
    <v-container fluid ref="mainContainer" class="ma-0 pa-0">

        <div v-if="!insufficientData" ref="chartdiv" class="chartDiv">
        </div>

        <v-card-text v-if="insufficientData" class="chartDiv text-center">
            <div style="margin-top: 100px;">
                <v-icon x-large color="grey">mdi-battery-charging-100</v-icon>
            </div>
            <div class="headline grey--text">
                Insufficient data
            </div>
            <div class="normal grey--text">
                Please check back later
            </div>
        </v-card-text>

        <json v-if="false" :data="data"/>

    </v-container>
</template>

<script>

import Json from 'vue-json-pretty';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

export default {

    components: {
        Json
    },

    props: {
        data: {
            required: true,
            type: Array,
        }
    },

    data() {
        return {
            height: 350,
            insufficientData: false,
            chart: null,
        }
    },

    watch: {
        data() {
            this.chart.data = this.getDataWithColors();
        }
    },

    mounted() {
        this.handleResize();
        this.createChart();
    },

    methods: {

        hasEnoughData() {
            if (this.data.length === 0) this.insufficientData = true;
            return !this.insufficientData;
        },

        createChart() {
            if (!this.hasEnoughData()) return;

            let chart = am4core.create(this.$refs.chartdiv, am4charts.PieChart3D);

            chart.paddingLeft = 0;
            chart.paddingRight = 0;
            chart.innerRadius = am4core.percent(40);
            chart.depth = 20;
            //chart.legend = new am4charts.Legend();

            let pieSeries = chart.series.push(new am4charts.PieSeries3D());
            pieSeries.dataFields.value = "value";
            pieSeries.dataFields.category = "name";
            pieSeries.tooltip.getFillFromObject = false;
            pieSeries.tooltip.background.fill = am4core.color("#329EF4");

            let hs = pieSeries.slices.template.states.getKey("hover");
            hs.properties.scale = 1.2;
            hs.properties.fillOpacity = 1;

            pieSeries.slices.template.fillOpacity = 0.8;
            pieSeries.slices.template.propertyFields.fill = "color";
            pieSeries.hiddenState.properties.opacity = 1;
            pieSeries.hiddenState.properties.endAngle = -90;
            pieSeries.hiddenState.properties.startAngle = -90;
            pieSeries.labels.template.disabled = true;
            pieSeries.ticks.template.disabled = true;

            chart.hiddenState.properties.radius = am4core.percent(0);

            chart.data = this.getDataWithColors();

            this.chart = chart;
        },

        getDataWithColors() {

            return this.data.map(item => {

                if (item.name === "Completed") item.color = am4core.color("#388E3C");
                if (item.name === "Quota") item.color = am4core.color("#FFAB00");
                if (item.name === "Profile") item.color = am4core.color("#927300");
                if (item.name === "Quality") item.color = am4core.color("#bf680c");
                if (item.name === "Duplicate") item.color = am4core.color("#e75930");
                if (item.name === "Security") item.color = am4core.color("#d20a0a");

                return item;
            })

            return this.data;
        },

        handleResize() {

            if (this.$refs.mainContainer.clientHeight) {

                let clientHeight = this.$refs.mainContainer.clientHeight - 70;

                // Maximum height for the chart
                if (clientHeight > 350) clientHeight = 350;

                this.height = clientHeight;
            }
        },
    }
}
</script>

<style scoped>

.chart {
    height: 350px;
    width: 500px;
    border: 1px solid yellow;
}

.chartDiv {
    height: 350px;
    width: 500px;
}

</style>
